import { isProdApi } from 'config/is-prod-api';

var config = null;

if (isProdApi) {
  config = require('./env/production').default;
} else if (process.env.NODE_ENV === 'staging') {
  config = require('./env/staging').default;
} else if (process.env.NODE_ENV === 'development') {
  config = require('./env/development').default;
} else {
  throw "Can't retrieve configurations since environment not set!";
}

export default config;
